import React, { useEffect } from 'react';
import { useBILogger } from '@wix/fe-essentials/react';
import { EmptyState, Button, Box, Text } from '@wix/design-system';
import { TRANSLATIONS } from '../../../constants/translations';
import { AUTOMATION_IDS } from '../../../constants/automationIds';
import { SvgPendingAppIcon } from './SvgPendingAppIcon';
import { t } from '../../../../../essentials/i18n';
import { BI_EVENTS_IDS } from '../../../constants/biEvents';
import { PENDING_APP_TAB_ID } from '../../../constants/constants';
import { getBIReportData } from '../../../utils/biEvents';

export interface PendingAppProps {
  onAddApp: () => void;
  trigger?: string;
}

export const PendingApp: React.FC<PendingAppProps> = ({
  onAddApp,
  trigger,
}) => {
  const logger = useBILogger();

  useEffect(() => {
    logger.log(
      getBIReportData(BI_EVENTS_IDS.TAB_LOAD, PENDING_APP_TAB_ID, {
        trigger,
      }),
    );
  }, []);

  return (
    <Box padding="SP7" align="center">
      <EmptyState
        image={<SvgPendingAppIcon />}
        title={
          <Box width={300} align="center">
            <Text size="small" weight="bold">
              {t(TRANSLATIONS.MY_BUSINESS.PENDING_APP.HEADER)}
            </Text>
          </Box>
        }
        subtitle={
          <Box width={300} align="center">
            <Text size="small">
              {t(TRANSLATIONS.MY_BUSINESS.PENDING_APP.TEXT)}
            </Text>
          </Box>
        }
      >
        <Button
          dataHook={AUTOMATION_IDS.MY_BUSINESS.PENDING_APP_INSTALL_ACTION}
          size="small"
          onClick={onAddApp}
        >
          {t(TRANSLATIONS.MY_BUSINESS.PENDING_APP.LINK)}
        </Button>
      </EmptyState>
    </Box>
  );
};
